import { Box, Skeleton } from "@mui/material";

const SignupFormSkeleton = () => {
  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      {/* Header Section */}
      <Box sx={{ textAlign: "center", mb: 3 }}>
        {/* Start today badge */}
        <Skeleton
          variant="rounded"
          width={100}
          height={28}
          sx={{ mx: "auto", mb: 1.85, borderRadius: "4px" }}
        />

        {/* Professional Plan Title */}
        <Skeleton
          variant="text"
          width="70%"
          height={40}
          sx={{ mx: "auto", mb: 1 }}
        />

        {/* Attendees info */}
        <Skeleton
          variant="text"
          width="60%"
          height={20}
          sx={{ mx: "auto" }}
        />
      </Box>

      {/* Green Trial Access Box Skeleton */}
      <Box
        sx={{
          bgcolor: "#F6F6F6",
          borderRadius: "8px",
          overflow: "hidden",
          mb: 2,
          border: "1px solid #e5e7eb",
        }}
      >
        {/* Green Header Skeleton */}
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{ bgcolor: "#b8e6d4" }}
        />

        {/* Content inside gray box */}
        <Box sx={{ p: "14px 16px" }}>
          {/* Feature Checkmarks Row */}
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}>
            {[1, 2, 3].map((_, idx) => (
              <Skeleton
                key={idx}
                variant="rounded"
                width={90}
                height={28}
                sx={{ borderRadius: "20px" }}
              />
            ))}
          </Box>

          {/* Price after trial info */}
          <Skeleton variant="text" width="70%" height={24} />
          <Skeleton variant="text" width="40%" height={16} sx={{ mt: 0.3 }} />
        </Box>
      </Box>

      {/* FREE With Your Trial Section Skeleton */}
      <Box
        sx={{
          backgroundColor: "#F6F6F6",
          borderRadius: "8px",
          overflow: "hidden",
          mb: 2,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: "8px 16px",
            backgroundColor: "#EBE5E5",
          }}
        >
          <Skeleton variant="text" width={150} height={24} />
          <Skeleton variant="rounded" width={70} height={28} sx={{ borderRadius: "6px" }} />
        </Box>

        <Box sx={{ p: "14px 18px" }}>
          {/* Bonus items grid */}
          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 2 }}>
            {[1, 2, 3, 4].map((_, idx) => (
              <Box key={idx} sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                <Skeleton variant="circular" width={16} height={16} sx={{ flexShrink: 0, mt: 0.5 }} />
                <Skeleton variant="text" width="80%" height={20} />
              </Box>
            ))}
          </Box>

          {/* Checklist item - centered */}
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
            <Skeleton variant="circular" width={18} height={18} />
            <Skeleton variant="text" width={180} height={20} />
          </Box>
        </Box>
      </Box>

      {/* Total Due Today Section Skeleton */}
      <Box
        sx={{
          bgcolor: "#1f2937",
          borderRadius: "12px",
          p: 2.5,
          mb: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Skeleton
            variant="text"
            width={120}
            height={28}
            sx={{ bgcolor: "rgba(255,255,255,0.1)" }}
          />
          <Skeleton
            variant="text"
            width={60}
            height={16}
            sx={{ bgcolor: "rgba(255,255,255,0.1)" }}
          />
        </Box>
        <Skeleton
          variant="text"
          width={60}
          height={48}
          sx={{ bgcolor: "rgba(255,255,255,0.1)" }}
        />
      </Box>

      {/* Email Input Section Skeleton */}
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="text" width={180} height={20} sx={{ mb: 1 }} />
        <Skeleton
          variant="rounded"
          height={48}
          sx={{ mb: 2, borderRadius: "8px" }}
        />
        <Skeleton
          variant="rounded"
          height={48}
          sx={{ borderRadius: "8px", bgcolor: "#e3f2fd" }}
        />
      </Box>
    </Box>
  );
};

export default SignupFormSkeleton;

